import { unref } from '@vue/composition-api';
import { pushDataLayer, changeObjKey } from './crmCommon.js';
import * as key from './crmKey.js';
import moment from 'moment';
import { priceOptions } from '@/components/products/ProductsFilter/options';

/**
 * 회원 가입 완료
 * signup_complete
 */
export function crmSignupComplete(data) {
	// 1. crm 양식에 맞게 key값 snake로 변환
	const tmp = changeObjKey(key.SIGNUP_COMPLETE_KEY, data);

	// 2. data에 해당 값이 없거나, 형식이 달라 별도로 추가 또는 수정한다.
	const result = {
		...tmp,
		user_id: 'GBIZ' + data['userNo'],
		recommendation_check: data['recommender'] ? 'true' : 'false',
		company_type: data['companyTypeCd'] === 'COR' ? '법인' : '개인',
		signup_date: moment().format('YYYY-MM-DD'),
		sms_receive_agreement: data['smsAgreeYn'] === 'Y' ? 'true' : 'false',
		email_receive_agreement: data['mailingAgreeYn'] === 'Y' ? 'true' : 'false',
		register_channel: 'Mobile',
	};

	// 3. 스크립트 실행
	pushDataLayer(result);
}

/**
 * 로그인
 * login
 */
export function crmLogin(userInfo, bizMoney) {
	const setUserStts = type => {
		switch (type) {
			case 'ACT':
				return '정상';
			case 'AWT':
				return '승인대기';
			case 'CAN':
				return '탈퇴';
			case 'LOK':
				return '잠금';
			case 'PAU':
				return '휴면';
			case 'SUS':
				return '중단';
			default:
				return '';
		}
	};

	let companyType = '';
	if (userInfo.bizNo) {
		companyType = /^8([1-7])/.test(userInfo.bizNo.replace(/\-/g, '').substr(3, 2)) ? '법인' : '개인';
	}

	const result = {
		event: 'login',
		user_id: 'GBIZ' + userInfo.userNo, //
		company_name: userInfo.companyName, // {상호명}',
		company_number: userInfo.bizNo ? userInfo.bizNo.replace(/\-/g, '') : userInfo.bizNo, // {사업자등록번호}',
		company_type: companyType, // {사업자 구분}',
		sms_receive_agreement: String(userInfo.smsAgreeYn === 'Y'), // {문자 알림 마케팅 수신 동의 여부}',
		email_receive_agreement: String(userInfo.mailingAgreeYn === 'Y'), // {이메일 알림 마케팅 수신 동의 여부}',
		user_grade: userInfo.companyLevelCd, // {회원 등급}',
		remain_target_amount: String(userInfo.levelUpAmount), // {회원 등급 상승까지 남은 금액}',
		signup_date: moment(userInfo.firstJoinDate).format('YYYY-MM-DD'), // {회원가입 연-월-일}',
		register_channel: userInfo.deviceType === 'M' ? 'Mobile' : userInfo.deviceType === 'W' ? 'PC' : '', // {가입채널 구분}',
		user_type: userInfo.masterYn === 'Y' ? '마스터' : '서브', // {회원 유형}',
		user_condition: setUserStts(userInfo.userStts), // {회원 상태}',
		total_login_count: String(userInfo.visitCnt), // {총 로그인 횟수}',
		last_login_date: userInfo.lastVisitDate ? moment(userInfo.lastVisitDate).format('YYYY-MM-DD') : '', // {최종 로그인 일자}',
		purchase_count: userInfo.totalOrderPaidCnt ? String(userInfo.totalOrderPaidCnt) : '0', // {총 구매 횟수}',
		purchase_price: userInfo.userTotalBuyAmount ? String(userInfo.userTotalBuyAmount) : '0', // {총 구매 액수}',
		last_order_date: userInfo.lastOrderDate ? moment(userInfo.lastOrderDate).format('YYYY-MM-DD') : '', // {최종 거래일}',
		estimate_count: String(userInfo.onlinePublish), // {견적서 작성 횟수}',
		remain_bizmoney: String(bizMoney), // {현재 비즈머니 잔액}',
		tempsend_count: String(userInfo.orderTempCount), // {현재 남아있는 임시 저장 발송 건수}'
	};

	pushDataLayer(result);
}

/**
 * [비즈 SHOP > 상품 상세 페이지] > 1. 상품 상세 페이지 진입
 * goods_detail_view
 */
export function crmGoodsDetailView(data) {
	if (!data) return;
	const tmp = changeObjKey(key.GOODS_DETAIL_VIEW_KEY, data);

	const result = {
		...tmp,
		goods_id: String(data['goodsNo']),
		regular_price: String(data['realPrice']),
		price: String(data['discountPrice']),
		expiry_date: String(data['limitDay']),
		category_id: String(data['categoryList'][0]),
		category_name: data['categoryName'].split(', '),
	};

	pushDataLayer(result);
}

/**
 * [비즈 SHOP > 상품 상세 페이지] > 2-1. 바로구매 버튼 클릭
 * goods_detail_goorder
 */
export function crmGoodsDetailGoorder() {
	pushDataLayer(key.GOODS_DETAIL_GOORDER_KEY);
}

/**
 * [비즈 SHOP > 상품 상세 페이지] > 2-2. 장바구니 버튼 클릭
 * goods_detail_addtocart
 */
export function crmGoodsDetailAddtocart() {
	pushDataLayer(key.GOODS_DETAIL_ADDTOCART_KEY);
}

/**
 * [비즈 SHOP > 상품 상세 페이지] > 2-3. 견적담기 버튼 클릭
 * goods_detail_estimate
 */
export function crmGoodsDetailEstimate() {
	pushDataLayer(key.GOODS_DETAIL_ESTIMATE_KEY);
}

/**
 * [비즈 SHOP > 상품 상세 페이지] > 2-5. 모바일 화면의 공유 버튼 - 페이스북
 * goods_detail_facebook_share
 */
export function crmGoodsDetailFacebookShare() {
	pushDataLayer(key.GOODS_DETAIL_FACEBOOK_SHARE_KEY);
}

/**
 * [비즈 SHOP > 상품 상세 페이지] > 2-5. 모바일 화면의 공유 버튼 - 카카오톡
 * goods_detail_kakaotalk_share
 */
export function crmGoodsDetailKakaotalkShare() {
	pushDataLayer(key.GOODS_DETAIL_KAKAOTALK_SHARE_KEY);
}

/**
 * [비즈 SHOP > 상품 상세 페이지] > 2-5. 모바일 화면의 공유 버튼 - URL
 * goods_detail_url_share
 */
export function crmGoodsDetailUrlShare() {
	pushDataLayer(key.GOODS_DETAIL_URL_SHARE_KEY);
}

/**
 * [비즈 SHOP > 상품 상세 페이지] > 3. 동일 카테고리 내 유사 가격 인기상품 섹션 내 클릭 > 3-4. 상품 클릭
 * goods_detail_related_click
 */
export function crmGoodsDetailRelatedClick(data) {
	const tmp = changeObjKey(key.GOODS_DETAIL_RELATED_CLICK_KEY, data);

	const result = {
		...tmp,
		goods_id: String(data['goodsNo']),
		price: String(data['discountPrice']),
		expiry_date: String(data['limitDay']),
	};

	pushDataLayer(result);
}

/**
 * [비즈 SHOP > 비즈 SHOP 페이지] > 1. 비즈 SHOP 페이지 접속 / 갱신
 * bizshop_view
 */
export function crmBizshopView(data) {
	let priceRange = '';
	let priceRangeValue = '';

	if (data.startPriceRange || data.endPriceRange) {
		priceRange = (data.startPriceRange || '') + '~' + (data.endPriceRange || '');
		// options.priceOptions에서 찾기
		priceRangeValue = priceOptions.filter(option => option.value === priceRange)[0]['label'];
	}

	const tmp = changeObjKey(key.BIZSHOP_VIEW_KEY, data);

	const result = {
		...tmp,
		// 성별 배열 -> 확인
		select_gender: data['exhGenderCd'].length > 0 ? data['exhGenderCd'] : ['MAN', 'WOMAN'],
		// 연령 배열 -> 확인
		select_age: data['exhAgeCd'].length > 0 ? data['exhAgeCd'] : ['10', '20', '30', '40', '50'],
		// 가격 -> 확인 (한글로 변경함. pc와 어떻게 맞출 지 검토 필요)
		select_price: priceRangeValue,
		// 정렬 방식 -> 확인
	};

	pushDataLayer(result);
}

/**
 * [비즈 SHOP > 비즈 SHOP 페이지] > 2. 비즈 SHOP 결과 내 재검색
 * bizshop_search_in_result
 */
export function crmBizshopSearchInResult(data) {
	let priceRange = '';
	let priceRangeValue = '';

	if (data.startPriceRange || data.endPriceRange) {
		priceRange = (data.startPriceRange || '') + '~' + (data.endPriceRange || '');
		// options.priceOptions에서 찾기
		priceRangeValue = priceOptions.filter(option => option.value === priceRange)[0]['label'];
	}

	const tmp = changeObjKey(key.BIZSHOP_SEARCH_IN_RESULT_KEY, data);

	const result = {
		...tmp,
		// 성별 배열 -> 확인
		select_gender: data['exhGenderCd'].length > 0 ? data['exhGenderCd'] : ['MAN', 'WOMAN'],
		// 연령 배열 -> 확인
		select_age: data['exhAgeCd'].length > 0 ? data['exhAgeCd'] : ['10', '20', '30', '40', '50'],
		// 가격 -> 확인
		select_price: priceRangeValue,
		// 정렬 방식 -> 확인
	};

	pushDataLayer(result);
}

/**
 * [비즈 SHOP > 비즈 SHOP 페이지] > 3-1. 바로주문 숏컷 클릭
 * bizshop_shortcut_goorder
 */
export function crmBizshopShortcutGoorder(data) {
	const tmp = changeObjKey(key.BIZSHOP_SHORTCUT_GOORDER_KEY, data);

	const result = {
		...tmp,
		goods_id: String(data['goodsNo']),
		price: String(data['discountPrice']),
		expiry_date: String(data['limitDay']),
	};

	pushDataLayer(result);
}

/**
 * [비즈 SHOP > 비즈 SHOP 페이지] > 3-2. 장바구니 담기 숏컷 클릭
 * bizshop_shortcut_addtocart
 */
export function crmBizshopShortcutAddtocart(data) {
	const tmp = changeObjKey(key.BIZSHOP_SHORTCUT_ADDTOCART_KEY, data);

	const result = {
		...tmp,
		goods_id: String(data['goodsNo']),
		price: String(data['discountPrice']),
		expiry_date: String(data['limitDay']),
	};

	pushDataLayer(result);
}

/**
 * [비즈 SHOP > 비즈 SHOP 페이지] > 3-3. 견적 담기 숏컷 클릭
 * bizshop_shortcut_estimate
 */
export function crmBizshopShortcutEstimate(data) {
	const tmp = changeObjKey(key.BIZSHOP_SHORTCUT_ESTIMATE_KEY, data);

	const result = {
		...tmp,
		goods_id: String(data['goodsNo']),
		price: String(data['discountPrice']),
		expiry_date: String(data['limitDay']),
	};

	pushDataLayer(result);
}

// ------

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 1. 온라인 견적서 페이지 진입
 * estimate_list_view
 */
export function crmEstimateListView() {
	const result = {
		event: 'estimate_list_view',
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 2. 등급 선택 > 2-1. 등급 선택 팝업
 * estimate_list_grade_view
 * 확인필요 - select 클릭할 때마다 스크립트 실행해도 되나요
 */
export function crmEstimateListGradeView() {
	const result = {
		event: 'estimate_list_grade_view',
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 2. 등급 선택 > 2-2. 등급 선택 완료
 * estimate_list_grade_confirm
 */
export function crmEstimateListGradeConfirm(data) {
	const result = {
		event: 'estimate_list_grade_confirm',
		select_grade: unref(data), // '{선택한 등급 명칭}'
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 3. 상품 검색 및 추가, 삭제 > 3-1. 상품 검색 완료
 * estimate_list_search
 */
export function crmEstimateListSearch(data) {
	const result = {
		event: 'estimate_list_search',
		keyword: data, // '{입력 검색어}'
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 3. 상품 검색 및 추가, 삭제 > 3-2. 상품 추가
 * estimate_list_goods_add
 */
export function crmEstimateListGoodsAdd(data) {
	const result = {
		event: 'estimate_list_goods_add',
		goods_id: String(data.goodsNo), // '{상품의 ID}',
		goods_name: data.goodsName, // '{상품명}',
		regular_price: String(data.salePrice), // '{상품의 정가}',
		price: String(data.realPrice), // '{상품의 판매가}',
		expiry_date: String(data.limitDay), // '{상품의 유효기간(day)}',
		category_id: String(data.categoryList[0]), // '{상품의 카테고리 ID}',
		category_name: data.categoryName.split(',')[0], // '{상품의 카테고리명}',
		brand_id: data.brandCode, // '{상품의 브랜드 ID}',
		brand_name: data.brandName, // '{상품의 브랜드명}'
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 3. 상품 검색 및 추가, 삭제 > 3-3. 추가한 상품 제거
 * estimate_list_goods_remove
 */
export function crmEstimateListGoodsRemove(data) {
	const result = {
		event: 'estimate_list_goods_remove',
		goods_id: [String(data.goodsNo)], // [상품의 ID 배열],
		goods_name: [data.goodsName], // [상품명 배열],
		regular_price: [String(data.salePrice)], // [상품의 정가 배열],
		price: [String(data.realPrice)], // [상품의 판매가 배열],
		expiry_date: [String(data.limitDay)], // [상품의 유효기간(day) 배열],
		category_id: [String(data.categoryList[0])], // [상품의 카테고리 ID 배열],
		category_name: [data.categoryName.split(',')[0]], // [상품의 카테고리명 배열],
		brand_id: [data.brandCode], // [상품의 브랜드 ID 배열],
		brand_name: [data.brandName], // [상품의 브랜드명 배열]
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)]  4. 담은 상품 불러오기 > 4-1. 담은 상품 불러오기 창 노출
 * estimate_list_goods_load_open
 */
export function crmEstimateListGoodsLoadOpen() {
	const result = {
		event: 'estimate_list_goods_load_open',
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 4. 담은 상품 불러오기 > 4-2. 담은 상품 불러오기 완료
 * estimate_list_goods_load_complete
 */
export function crmEstimateListGoodsLoadComplete(data) {
	const result = {
		event: 'estimate_list_goods_load_complete',
		goods_id: data.map(item => String(item.goodsNo)), // [상품의 ID 배열],
		goods_name: data.map(item => item.goodsName), // [상품명 배열],
		regular_price: data.map(item => String(item.realPrice)), // [상품의 정가 배열],
		price: data.map(item => String(item.salePrice)), // [상품의 판매가 배열],
		expiry_date: data.map(item => String(item.limitDay)), // [상품의 유효기간(day) 배열],
		category_id: data.map(item => String(item.categoryList[0])), // [상품의 카테고리 ID 배열],
		category_name: data.map(item => item.categoryName.split(',')[0]), // [상품의 카테고리명 배열],
		brand_id: data.map(item => item.brandCode), // [상품의 브랜드 ID 배열],
		brand_name: data.map(item => item.brandName), // [상품의 브랜드명 배열]
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 4. 담은 상품 불러오기 > 4-3. 담은 상품 삭제
 * estimate_list_goods_load_remove
 */
export function crmEstimateListGoodsLoadRemove(data) {
	let result = {};
	if (Array.isArray(data)) {
		result = {
			event: 'estimate_list_goods_load_remove',
			goods_id: data.map(item => String(item.goodsNo)), // [상품의 ID 배열],
			goods_name: data.map(item => item.goodsName), // [상품명 배열],
			regular_price: data.map(item => String(item.realPrice)), // [상품의 정가 배열],
			price: data.map(item => String(item.salePrice)), // [상품의 판매가 배열],
			expiry_date: data.map(item => String(item.limitDay)), // [상품의 유효기간(day) 배열],
			category_id: data.map(item => String(item.categoryList[0])), // [상품의 카테고리 ID 배열],
			category_name: data.map(item => item.categoryName.split(',')[0]), // [상품의 카테고리명 배열],
			brand_id: data.map(item => item.brandCode), // [상품의 브랜드 ID 배열],
			brand_name: data.map(item => item.brandName), // [상품의 브랜드명 배열]
		};
	} else {
		result = {
			event: 'estimate_list_goods_load_remove',
			goods_id: [String(data.goodsNo)], // [상품의 ID 배열],
			goods_name: [data.goodsName], // [상품명 배열],
			regular_price: [String(data.salePrice)], // [상품의 정가 배열],
			price: [String(data.realPrice)], // [상품의 판매가 배열],
			expiry_date: [String(data.limitDay)], // [상품의 유효기간(day) 배열],
			category_id: [String(data.categoryList[0])], // [상품의 카테고리 ID 배열],
			category_name: [data.categoryName.split(',')[0]], // [상품의 카테고리명 배열],
			brand_id: [data.brandCode], // [상품의 브랜드 ID 배열],
			brand_name: [data.brandName], // [상품의 브랜드명 배열]
		};
	}

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 5. 임시 저장 불러오기 > 5-1. 임시 저장 불러오기 창 노출
 * estimate_list_temp_save_load_open
 */
export function crmEstimateListTempSaveLoadOpen() {
	const result = {
		event: 'estimate_list_temp_save_load_open',
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 5. 임시 저장 불러오기 > 5-2. 임시 저장 - 견적 삭제
 * estimate_list_temp_save_load_remove
 */
export function crmEstimateListTempSaveLoadRemove(data) {
	const result = {
		event: 'estimate_list_temp_save_load_remove',
		quote_name: data.estimateNm, // '{견적명}',
		quote_date: moment(String(data.firstSendDate)).format('YYYY-MM-DD HH:mm'), // '{견적 저장 일시}',
		quote_price: String(data.totalAmount), // '{최종 견적 금액}'
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(상품 추가/제거/불러오기)] 5. 임시 저장 불러오기 > 5-3. 임시 저장 - 불러오기 완료
 * estimate_list_temp_save_load_complete
 */
export function crmEstimateListTempSaveLoadComplete(data) {
	const result = {
		event: 'estimate_list_temp_save_load_complete',
		quote_name: data.estimateNm, // '{견적명}',
		quote_date: moment(String(data.firstSendDate)).format('YYYY-MM-DD HH:mm'), // '{견적 저장 일시}',
		quote_price: String(data.totalAmount), // '{최종 견적 금액}'
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(견적서작성/임시저장)] 1. 온라인 견적 임시저장/바로 구매 > 1-1. 임시저장
 * estimate_list_temp_save
 */
export function crmEstimateListTempSave(data) {
	const result = {
		event: 'estimate_list_temp_save',
		quote_name: data.estimateNm, // '{견적명}',
		goods_id: data.goodsList.map(item => String(item.goodsNo)), // [상품의 ID 배열],
		goods_name: data.goodsList.map(item => item.goodsName), // [상품명 배열],
		regular_price: data.goodsList.map(item => String(item.salePrice)), // [상품의 정가 배열],
		price: data.goodsList.map(item => String(item.realPrice)), // [상품의 판매가 배열],
		expiry_date: data.goodsList.map(item => String(item.limitDay)), // [상품의 유효기간(day) 배열],
		category_id: data.goodsList.map(item => String(item.categoryList[0])), // [상품의 카테고리 ID 배열],
		category_name: data.goodsList.map(item => item.categoryName.split(',')[0]), // [상품의 카테고리명 배열],
		brand_id: data.goodsList.map(item => item.brandCode), // [상품의 브랜드 ID 배열],
		brand_name: data.goodsList.map(item => item.brandName), // [상품의 브랜드명 배열],
		quantity: data.goodsList.map(item => String(item.goodsCount)), // [상품 수량 배열]
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(견적서작성/임시저장)] 1. 온라인 견적 임시저장/바로 구매 > 1-2. 바로구매 클릭
 * estimate_list_direct_checkout_click
 */
export function crmEstimateListDirectCheckoutClick(data, estimateNm) {
	const result = {
		event: 'estimate_list_direct_checkout_click',
		quote_name: estimateNm, // '{견적명}',
		goods_id: data.map(item => String(item.goodsNo)), // [상품의 ID 배열],
		goods_name: data.map(item => item.goodsName), // [상품명 배열],
		regular_price: data.map(item => String(item.salePrice)), // [상품의 정가 배열],
		price: data.map(item => String(item.realPrice)), // [상품의 판매가 배열],
		expiry_date: data.map(item => String(item.limitDay)), // [상품의 유효기간(day) 배열],
		category_id: data.map(item => String(item.categoryList[0])), // [상품의 카테고리 ID 배열],
		category_name: data.map(item => item.categoryName.split(',')[0]), // [상품의 카테고리명 배열],
		brand_id: data.map(item => item.brandCode), // [상품의 브랜드 ID 배열],
		brand_name: data.map(item => item.brandName), // [상품의 브랜드명 배열],
		quantity: data.map(item => String(item.goodsCount)), // [상품 수량 배열]
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(견적서작성/임시저장)] 2. 견적함 관리 버튼 클릭
 * estimate_list_estimatebox_click
 */
export function crmEstimateListEstimateboxClick() {
	const result = {
		event: 'estimate_list_estimatebox_click',
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서(견적서작성/임시저장)] 3. 견적서 작성 버튼 클릭 > 3-1. 견적서 작성 버튼 클릭
 * online_estimate_create
 */
export function crmOnlineEstimateCreate(data, estimateNm) {
	const result = {
		event: 'online_estimate_create',
		quote_name: estimateNm, // '{견적명}',
		goods_id: data.map(item => String(item.goodsNo)), // [상품의 ID 배열],
		goods_name: data.map(item => item.goodsName), // [상품명 배열],
		regular_price: data.map(item => String(item.salePrice)), // [상품의 정가 배열],
		price: data.map(item => String(item.realPrice)), // [상품의 판매가 배열],
		expiry_date: data.map(item => String(item.limitDay)), // [상품의 유효기간(day) 배열],
		category_id: data.map(item => String(item.categoryList[0])), // [상품의 카테고리 ID 배열],
		category_name: data.map(item => item.categoryName.split(',')[0]), // [상품의 카테고리명 배열],
		brand_id: data.map(item => item.brandCode), // [상품의 브랜드 ID 배열],
		brand_name: data.map(item => item.brandName), // [상품의 브랜드명 배열],
		quantity: data.map(item => String(item.goodsCount)), // [상품 수량 배열]
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 견적함 관리] 3. 견적서 작성 버튼 클릭 > 1. 견적함 관리 페이지 진입
 * estimate_manage_view
 */
export function crmEstimateManageView() {
	const result = {
		event: 'estimate_manage_view',
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 견적함 관리] 3. 견적서 작성 버튼 클릭 > 2. 견적 보기 버튼 클릭
 * estimate_manage_quote_view_click
 */
export function crmEstimateManageQuoteViewClick(data) {
	const result = {
		event: 'estimate_manage_quote_view_click',
		quote_name: data.estimateNm, // '{견적명}',
		quote_date: moment(String(data.firstSendDate)).format('YYYY-MM-DD HH:mm'), // '{견적 발행 일시}',
		quote_type: data.estimateSendTypeName, // '{발행 유형}',
		quote_price: String(data.totalAmount), // '{최종 견적 금액}'
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 견적함 관리] 3. 견적서 작성 버튼 클릭 > 3. 견적 검색
 * estimate_manage_search
 */
export function crmEstimateManageSearch(data) {
	const result = {
		event: 'estimate_manage_search',
		keyword: data.searchWord ? data.searchWord : '', // '{입력 키워드}',
		start_date: moment(data.start).format('YYYY-MM-DD'), // '{시작 발행 일자}',
		end_date: moment(data.end).format('YYYY-MM-DD'), // '{끝 발행 일자}'
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서 조회] 1. 온라인 견적서 팝업 등장
 * online_estimate_view
 */
export function crmOnlineEstimateView(data) {
	const result = {
		event: 'online_estimate_view',
		company_name: data.companyName, // '{기업명}',
		quote_name: data.estimateName, // '{견적명}',
		quote_date: moment().format('YYYY-MM-DD'), // '{견적일자}',
		quote_price: String(data.estimateProductTotalPrice), // '{최종 견적 금액}',
		goods_id: data.estimateProductList.map(item => String(item.goodsNo)), // [상품의 ID 배열],
		goods_name: data.estimateProductList.map(item => item.goodsName), // [상품명 배열],
		regular_price: data.estimateProductList.map(item => String(item.salePrice)), // [상품의 정가 배열],
		price: data.estimateProductList.map(item => String(item.realPrice)), // [상품의 판매가 배열],
		expiry_date: data.estimateProductList.map(item => String(item.limitDay)), // [상품의 유효기간(day) 배열],
		category_id: data.estimateProductList.map(item => String(item.categoryList[0])), // [상품의 카테고리 ID 배열],
		category_name: data.estimateProductList.map(item => item.categoryName.split(',')[0]), // [상품의 카테고리명 배열],
		brand_id: data.estimateProductList.map(item => item.brandCode), // [상품의 브랜드 ID 배열],
		brand_name: data.estimateProductList.map(item => item.brandName), // [상품의 브랜드명 배열],
		quantity: data.estimateProductList.map(item => String(item.goodsCount)), // [상품 수량 배열]
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서 조회] 2. 이메일 발송
 * online_estimate_email_send
 */
export function crmOnlineEstimateEmailSend(data) {
	const result = {
		event: 'online_estimate_email_send',
		company_name: data.companyName, // '{기업명}',
		quote_name: data.estimateName, // '{견적명}',
		quote_date: moment().format('YYYY-MM-DD'), // '{견적일자}',
		quote_price: String(data.estimateProductTotalPrice), // '{최종 견적 금액}',
		goods_id: data.estimateProductList.map(item => String(item.goodsNo)), // [상품의 ID 배열],
		goods_name: data.estimateProductList.map(item => item.goodsName), // [상품명 배열],
		regular_price: data.estimateProductList.map(item => String(item.salePrice)), // [상품의 정가 배열],
		price: data.estimateProductList.map(item => String(item.realPrice)), // [상품의 판매가 배열],
		expiry_date: data.estimateProductList.map(item => String(item.limitDay)), // [상품의 유효기간(day) 배열],
		category_id: data.estimateProductList.map(item => String(item.categoryList[0])), // [상품의 카테고리 ID 배열],
		category_name: data.estimateProductList.map(item => item.categoryName.split(',')[0]), // [상품의 카테고리명 배열],
		brand_id: data.estimateProductList.map(item => item.brandCode), // [상품의 브랜드 ID 배열],
		brand_name: data.estimateProductList.map(item => item.brandName), // [상품의 브랜드명 배열],
		quantity: data.estimateProductList.map(item => String(item.goodsCount)), // [상품 수량 배열]
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서 조회] 3. PDF 다운로드
 * online_estimate_pdf_download
 */
export function crmOnlineEstimatePdfDownload(data) {
	const result = {
		event: 'online_estimate_pdf_download',
		company_name: data.companyName, // '{기업명}',
		quote_name: data.estimateName, // '{견적명}',
		quote_date: moment().format('YYYY-MM-DD'), // '{견적일자}',
		quote_price: String(data.estimateProductTotalPrice), // '{최종 견적 금액}',
		goods_id: data.estimateProductList.map(item => String(item.goodsNo)), // [상품의 ID 배열],
		goods_name: data.estimateProductList.map(item => item.goodsName), // [상품명 배열],
		regular_price: data.estimateProductList.map(item => String(item.salePrice)), // [상품의 정가 배열],
		price: data.estimateProductList.map(item => String(item.realPrice)), // [상품의 판매가 배열],
		expiry_date: data.estimateProductList.map(item => String(item.limitDay)), // [상품의 유효기간(day) 배열],
		category_id: data.estimateProductList.map(item => String(item.categoryList[0])), // [상품의 카테고리 ID 배열],
		category_name: data.estimateProductList.map(item => item.categoryName.split(',')[0]), // [상품의 카테고리명 배열],
		brand_id: data.estimateProductList.map(item => item.brandCode), // [상품의 브랜드 ID 배열],
		brand_name: data.estimateProductList.map(item => item.brandName), // [상품의 브랜드명 배열],
		quantity: data.estimateProductList.map(item => String(item.goodsCount)), // [상품 수량 배열]
	};

	pushDataLayer(result);
}

/**
 * [온라인 견적서 > 온라인 견적서 조회] 4. 인쇄
 * online_estimate_print
 */
// export function crmOnlineEstimatePrint (data) {
//     const result = {
//         'event': 'online_estimate_print',
//         'company_name': '',  // '{기업명}',
//         'quote_name': '',  // '{견적명}',
//         'quote_date': '',  // '{견적일자}',
//         'quote_price': '',  // '{최종 견적 금액}',
//         'goods_id': '',  // [상품의 ID 배열],
//         'goods_name': '',  // [상품명 배열],
//         'regular_price': '',  // [상품의 정가 배열],
//         'price': '',  // [상품의 판매가 배열],
//         'expiry_date': '',  // [상품의 유효기간(day) 배열],
//         'category_id': '',  // [상품의 카테고리 ID 배열],
//         'category_name': '',  // [상품의 카테고리명 배열],
//         'brand_id': '',  // [상품의 브랜드 ID 배열],
//         'brand_name': '',  // [상품의 브랜드명 배열],
//         'quantity': '',  // [상품 수량 배열]
//     };

//     pushDataLayer(result);
// }

/** */

/**
 * [비즈 SHOP > 이벤트·기획전] 1. 이벤트·기획전 페이지 진입
 * event_list_view
 */
export function crmEventListView() {
	const result = {
		event: 'event_list_view',
	};

	pushDataLayer(result);
}

/**
 * [비즈 SHOP > 이벤트·기획전] 2. 이벤트·기획전 상세페이지
 * event_detail_view
 */
export function crmEventDetailView(eventSeq, detail) {
	setTimeout(() => {
		const result = {
			event: 'event_detail_view',
			event_id: eventSeq, // '{이벤트 ID}',
			event_title: unref(detail).eventName, // '{이벤트 제목}'
		};

		pushDataLayer(result);
	}, 500); // eventName이 undefined로 나오는 바람에 settimeout 사용
}
/**
 * [비즈 SHOP > 이벤트·기획전] 2. 이벤트·기획전 상세페이지 > 버튼클릭
 * event_detail_btn_click
 */
export function crmEventDetailBtnClick(payload) {
	const result = {
		event: 'event_detail_btn_click',
		...payload,
	};
	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > 메인 배너 클릭] 1. 메인 페이지 최상단 배너 클릭
 * main_top_banner_click
 */
export function crmMainTopBannerClick(data) {
	const result = {
		event: 'main_top_banner_click',
		banner_title: data, // '{배너 제목}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > 메인 배너 클릭] 2-1. 슬라이더 배너 이미지 클릭
 * main_slider_click
 */
export function crmMainSliderClick(data, list) {
	const result = {
		event: 'main_slider_click',
		slide_no: String(list.findIndex(obj => obj.exhBannerSeq === data.exhBannerSeq) + 1), // '{슬라이더 번호}',
		slide_title: data.bannerName, // '{슬라이드 제목}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > 메인 배너 클릭] 2-2. 슬라이더 배너 하단 탭 영역 클릭
 * main_slider_tab_click
 */
// export function crmMainSliderTabClick (data) {
//     const result = {
//         'event': 'main_slider_tab_click',
//         'tab_title': data, // '{배너 제목}'
//     };

//     pushDataLayer(result);
// }

/**
 * [메인 페이지 및 네비게이션 > 메인 배너 클릭] 3. 중간 배너 클릭
 * main_middle_banner_click
 */
export function crmMainMiddleBannerClick(data) {
	const result = {
		event: 'main_middle_banner_click',
		banner_no: '1', // '{배너 번호}',
		banner_title: data, // '{배너 제목}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > 온라인 견적서]
 * 1. 견적서 작성 클릭 main_estimate_write
 * 2. 장바구니 담기 main_estimate_addtocart
 * 3. 바로주문 main_estimate_goorder
 * 모바일 해당없음.
 */

/**
 * [메인 페이지 및 네비게이션 > biz 인기상품 / biz 테마 추천] 1. biz 인기상품
 * 1-1. biz 인기상품 카테고리 탭 클릭
 * main_biz_popular_tab_click
 */
export function crmMainBizPopularTabClick(data) {
	const result = {
		event: 'main_biz_popular_tab_click',
		tab_name: data, // '{클릭한 카테고리명}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > biz 인기상품 / biz 테마 추천] 1. biz 인기상품
 * 1-2. biz 인기상품 상품 클릭
 * main_biz_popular_goods_click
 */
export function crmMainBizPopularGoodsClick(data) {
	const result = {
		event: 'main_biz_popular_goods_click',
		goods_id: String(data.goodsNo), //{상품의 ID}',
		goods_name: data.goodsName, //{상품명}',
		regular_price: String(data.realPrice), //{상품의 정가}',
		price: String(data.discountPrice), //{상품의 판매가}',
		expiry_date: String(data.limitDay), //{상품의 유효기간(day)}',
		brand_id: data.brandCode, //{상품의 브랜드 ID}',
		brand_name: data.brandName, //{상품의 브랜드명}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > biz 인기상품 / biz 테마 추천] 2. biz 테마 추천
 * 2-1. biz 테마 추천 - 테마 탭 클릭
 * main_biz_theme_tab_click
 */
export function crmMainBizThemeTabClick(data) {
	const result = {
		event: 'main_biz_theme_tab_click',
		tab_name: data, // '{클릭한 테마명}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > biz 인기상품 / biz 테마 추천] 2. biz 테마 추천
 * 2-2. biz 테마 추천 - 상품 클릭
 * main_biz_theme_goods_click
 */
export function crmMainBizThemeGoodsClick(data) {
	const result = {
		event: 'main_biz_theme_goods_click',
		goods_id: String(data.goodsNo), //{상품의 ID}',
		goods_name: data.goodsName, //{상품명}',
		regular_price: String(data.salePrice), //{상품의 정가}',
		price: String(data.discountPrice), //{상품의 판매가}',
		expiry_date: String(data.limitDay), //{상품의 유효기간(day)}',
		brand_id: data.brandCode, //{상품의 브랜드 ID}',
		brand_name: data.brandName, //{상품의 브랜드명}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > biz 인기상품 / biz 테마 추천] 3. 기업고객센터 영역
 * main_corp_service_center_click
 */
export function crmMainCorpServiceCenterClick(data) {
	const result = {
		event: 'main_corp_service_center_click',
		title: data, // '{클릭 항목의 제목}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > 네비게이션] 2. 상단 메뉴 - 검색
 * search_result
 */
export function crmSearchResult(data) {
	const result = {
		event: 'search_result',
		keyword: data, // '{입력 검색어}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > 네비게이션] 3. 플로팅 버튼
 * 3-1. 플로팅 메뉴 클릭
 * floating_click
 */
export function crmFloatingClick(data) {
	const result = {
		event: 'floating_click',
		menu: data, // '{클릭한 버튼명}'
	};

	pushDataLayer(result);
}

/**
 * [메인 페이지 및 네비게이션 > 네비게이션] 3. 플로팅 버튼
 * 3-2. 플로팅 메뉴 - 최근 본 상품 클릭
 * floating_recent_goods_click
 */
// export function crmFloatingRecentGoodsClick (data) {
//     const result = {
//         'event': 'floating_recent_goods_click',
//         'goods_id': '', // '{상품의 ID}',
//         'goods_name': '', // '{상품명}',
//         'regular_price': '', // '{상품의 정가}',
//         'price': '', // '{상품의 판매가}',
//         'expiry_date': '', // '{상품의 유효기간(day)}',
//         'brand_id': '', // '{상품의 브랜드 ID}',
//         'brand_name': '', // '{상품의 브랜드명}'
//       };
//       console.log("result", result);

//     pushDataLayer(result);
// }

/**
 * [설문발송]의 설문관리, 일반형 발송 - 주문정보 페이지, 추첨형 발송 - 주문정보 페이지, 결제정보 페이지, 주문완료
 * 는 mw에 화면 없으므로, 해당없음.
 */

/**
 * [설문발송 > 설문 내역·통계] 1. 설문 내역·통계 페이지 진입
 * survey_statistics_list_view
 */
export function crmSurveyStatisticsListView() {
	const result = {
		event: 'survey_statistics_list_view',
	};

	pushDataLayer(result);
}

/**
 * [설문발송 > 설문 내역·통계] 2. 설문 내역·통계 상세 페이지 진입
 * survey_detail_purchase_history
 */
export function crmSurveyDetailPurchaseHistory(data) {
	const result = {
		event: 'survey_detail_purchase_history',
		transaction_id: data.orderNo, // {주문 번호}',
		order_name: data.surveyMgmtTitle, // {주문명}',
		survey_type: data.orderTypeNm, // {설문 형태}',
		receiver: data.subjectsCnt, // {총 수신자 수}',
		participants: data.respondentsCnt, // {참여자 수}',
		response_period_start: data.startDate, // {설문 시작일}',
		response_period_end: data.endDate, // {설문기간 종료일}'
	};

	pushDataLayer(result);
}

/**
 * [설문발송 > 설문 내역·통계] 3. 설문 내역·통계 상세 - 응답 통계 - 설문결과 다운로드
 * survey_detail_result_download_click
 */
export function crmSurveyDetailResultDownloadClick(data) {
	const result = {
		event: 'survey_detail_result_download_click',
		transaction_id: data.orderNo, // {주문 번호}',
		order_name: data.surveyMgmtTitle, // {주문명}',
		survey_type: data.surveyType.toLowerCase() === 'normal' ? '일반형' : '추첨형', // {설문 형태}',
		receiver: data.subjectsCnt, // {총 수신자 수}',
		participants: data.respondentsCnt, // {참여자 수}',
		response_period_start: data.startDate, // {설문 시작일}',
		response_period_end: data.endDate, // {설문기간 종료일}'
	};

	pushDataLayer(result);
}

/**
 * [설문발송 > 설문 내역·통계] 4. 설문 내역·통계 상세 - 당첨자명단 - 당첨자명단 다운로드
 * survey_detail_winner_download_click
 */
export function crmSurveyDetailWinnerDownloadClick(data, list) {
	const result = {
		event: 'survey_detail_winner_download_click',
		transaction_id: data.orderNo, // {주문 번호}',
		order_name: data.surveyMgmtTitle, // {주문명}',
		survey_type: data.surveyType.toLowerCase() === 'normal' ? '일반형' : '추첨형', // {설문 형태}',
		receiver: data.subjectsCnt, // {총 수신자 수}',
		participants: data.respondentsCnt, // {참여자 수}',
		response_period_start: data.startDate, // {설문 시작일}',
		response_period_end: data.endDate, // {설문기간 종료일}'
		win_goods_name: list.map(item => item.goodsName), // [당첨 상품명 배열]
	};

	pushDataLayer(result);
}

// 24.4 연락처 관리 (컨플 메뉴명)
/**
 * 1. 주문정보 내 주소록 가져오기 버튼 클릭
 * order_receiveinfo_address_import_click
 */
export function orderReceiveinfoAddressImportClick() {
	// console.log('orderReceiveinfoAddressImportClick 실행');
	const result = {
		event: 'order_receiveinfo_address_import_click',
	};

	pushDataLayer(result);
}

/**
 * 2. 주문정보 주소록 가져오기 내 탭 클릭(그룹/연락처)
 * order_receiveinfo_address_import_tab_click
 */
export function orderReceiveinfoAddressImportTabClick(payload) {
	// console.log('orderReceiveinfoAddressImportTabClick payload:', payload);
	const result = {
		event: 'order_receiveinfo_address_import_tab_click',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 3. 주문정보 주소록 가져오기 내 탭 다운스크롤에 그룹 선택
 * order_receiveinfo_address_import_group_tab_scroll_click
 */
export function orderReceiveinfoAddressImportGroupTabScrollClick(payload) {
	// console.log('order_receiveinfo_address_import_group_tab_scroll_click payload:', payload);
	const result = {
		event: 'order_receiveinfo_address_import_group_tab_scroll_click',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 4. 주문정보 주소록 가져오기 내 그룹 탭 목록(번호) 선택 및 확인 클릭
 * order_receiveinfo_address_import_group_tab_list_click
 */
export function orderReceiveinfoAddressImportGroupTabListClick(payload) {
	// console.log('4 주문정보 주소록 가져오기 내 그룹 탭 목록(번호) 선택 및 확인 클릭:', payload);
	const result = {
		event: 'order_receiveinfo_address_import_group_tab_list_click',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 5. 주문정보 주소록 가져오기 내 그룹 탭 검색 실행
 * order_receiveinfo_address_import_group_tab_search_result
 */
export function orderReceiveinfoAddressImportGroupTabSearchResult() {
	// console.log('5 주문정보 주소록 가져오기 내 그룹 탭 검색 실행:');
	const result = {
		event: 'order_receiveinfo_address_import_group_tab_search_result',
	};

	pushDataLayer(result);
}

/**
 * 6. 주문정보 주소록 가져오기 내 연락처 탭 목록(번호) 선택 및 확인 클릭
 * order_receiveinfo_address_import_contact_tab_list_click
 */
export function orderReceiveinfoAddressImportContactTabListClick(payload) {
	// console.log('6 주문정보 주소록 가져오기 내 연락처 탭 목록(번호) 선택 및 확인 클릭:');
	const result = {
		event: 'order_receiveinfo_address_import_contact_tab_list_click',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 7. 주문정보 주소록 가져오기 내 연락처 탭 검색 실행
 * order_receiveinfo_address_import_contact_tab_search_result
 */
export function orderReceiveinfoAddressImportContactTabSearchResult() {
	// console.log('7. 주문정보 주소록 가져오기 내 연락처 탭 검색 실행:');
	const result = {
		event: 'order_receiveinfo_address_import_contact_tab_search_result',
	};

	pushDataLayer(result);
}

/**
 * 8. 마이비즈 연락처 관리 페이지 진입
 * contact_management_view
 */
export function contactManagementView() {
	// console.log('8. 마이비즈 연락처 관리 페이지 진입:');
	const result = {
		event: 'contact_management_view',
	};

	pushDataLayer(result);
}

/**
 * 9. 마이비즈 연락처 관리 페이지 내 검색 완료
 * contact_management_view
 */
export function contactManagementSearch(payload) {
	// console.log('9. 마이비즈 연락처 관리 페이지 내 검색 완료:', payload);
	const result = {
		event: 'contact_management_search',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 10. 마이비즈 연락처 관리 페이지 수정/삭제 버튼 클릭
 * contact_management_modification_deletion_click
 */
export function contactManagementModificationDeletionClick(payload) {
	// console.log('10. 마이비즈 연락처 관리 페이지 수정/삭제 버튼 클릭', payload);
	const result = {
		event: 'contact_management_modification_deletion_click',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 11. 마이비즈 연락처 관리 페이지 그룹등록 버튼 클릭
 * contact_management_group_btn_click
 */
export function contactManagementGroupBtnClick() {
	// console.log('11. 마이비즈 연락처 관리 페이지 그룹등록 버튼 클릭');
	const result = {
		event: 'contact_management_group_btn_click',
	};

	pushDataLayer(result);
}

/**
 * 12. 마이비즈 연락처 관리 페이지 내 그룹명 등록 완료
 * contact_management_group_add_complete
 */
export function contactManagementGroupAddComplete(payload) {
	console.log('12. 마이비즈 연락처 관리 페이지 내 그룹명 등록 완료', payload);
	const result = {
		event: 'contact_management_group_add_complete',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 13. 마이비즈 연락처 관리 페이지 내 연락처 등록 클릭
 * contact_management_contact_btn_click
 */
export function contactManagementContactBtnClick() {
	// console.log('13. 마이비즈 연락처 관리 페이지 내 연락처 등록 클릭');
	const result = {
		event: 'contact_management_contact_btn_click',
	};

	pushDataLayer(result);
}

/**
 * 14. 마이비즈 연락처 관리 내 연락처 등록 다운스크롤 그룹 선택
 * contact_management_contact_group_list_click
 */
export function contactManagementContactGroupListClick(payload) {
	// console.log('14. 마이비즈 연락처 관리 내 연락처 등록 다운스크롤 그룹 선택', payload);
	const result = {
		event: 'contact_management_contact_group_list_click',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 15. MFO는 해당 이벤트 해당 없음 X
 * contact_management_contact_excel_upload
 */

/**
 * 16. MFO는 해당 이벤트 해당 없음 X
 * contact_management_contact_excel_form_download
 */

/**
 * 17. 마이비즈 연락처 관리 내 연락처 등록 동의하고 등록 완료
 * contact_management_contact_add_complete
 */
export function contactManagementContactAddComplete(payload) {
	// console.log('17. 마이비즈 연락처 관리 내 연락처 등록 동의하고 등록 완료', payload);
	const result = {
		event: 'contact_management_contact_add_complete',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 18. MFO는 해당 이벤트 해당 없음 X
 */

/**
 * 19. 회원가입 페이지 내 사업자인증 클릭 후 인증 완료
 * signup_brnumber_certification_click
 */
export function signupBrnumberCertificationClick(payload) {
	// console.log('19. 회원가입 페이지 내 사업자인증 클릭 후 인증 완료', payload);
	const result = {
		event: 'signup_brnumber_certification_click',
		...payload,
	};

	pushDataLayer(result);
}

/**
 * 20. MFO는 해당 이벤트 해당 없음 X
 */
// 24.4 연락처 관리 (컨플 메뉴명) END

// 24.6 AI메시지/래퍼배너 클릭 추가 (컴플 메뉴명)

// 1. 주문정보 내 AI메시지 버튼 클릭
export function orderReceiveinfoMessageAiMessageWriteClick(payload) {
	// console.log('1. 주문정보 내 AI메시지 버튼 클릭', payload);
	const result = {
		event: 'order_receiveinfo_message_ai_message_write_click',
		...payload,
	};

	pushDataLayer(result);
}

// 24.6 AI메시지/래퍼배너 클릭 추가 (컴플 메뉴명) END
